import { getPrefixedRoute } from 'services/theming';

export const paths = {
  cart: () => getPrefixedRoute('/cart'),
  checkout: () => getPrefixedRoute('/checkout'),
  catalogMarket: () => getPrefixedRoute('/catalog-market'),
  customers: () => getPrefixedRoute('/customers?t=0&g=2'),
  editProfile: (profileId?: number) => getPrefixedRoute(`/edit/profile/${profileId}`),
  emailNotifications: () => getPrefixedRoute('/notifications/email'),
  explore: () => getPrefixedRoute('/explore'),
  logistics: () => getPrefixedRoute('/seller-locations'),
  accessDenied: () => getPrefixedRoute('/access-denied'),
  login: () => getPrefixedRoute('/login'),
  notFound: () => getPrefixedRoute('/404'),
  market: () => getPrefixedRoute('/market'),
  marketHome: () => getPrefixedRoute('/market/home'),
  marketing: () => getPrefixedRoute('/profile/marketing'),
  operations: () => getPrefixedRoute('/operations'),
  payments: () => getPrefixedRoute('/payments'),
  profile: () => getPrefixedRoute('/profile'),
  pushNotifications: () => getPrefixedRoute('/notifications/push'),
  quotes: () => getPrefixedRoute('/quotes'),
  reports: () => getPrefixedRoute('/reports'),
  packhouse: () => getPrefixedRoute('/packhouse'),
  sales: () => getPrefixedRoute('/sales'),
  sellerMarket: () => getPrefixedRoute('/seller/products'),
  shipments: () => getPrefixedRoute('/shipments'),
  userSettings: () => getPrefixedRoute('/profile/user'),
  users: () => getPrefixedRoute('/users?t=0&g=2'),
};
